import { render, staticRenderFns } from "./OrganizationUserPermissions.vue?vue&type=template&id=34c3784e&"
import script from "./OrganizationUserPermissions.vue?vue&type=script&lang=js&"
export * from "./OrganizationUserPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports